import { useManualQuery } from "graphql-hooks";

const GET_FORBIDDEN_ML_CATEGORIES = `
  query GetForbiddenMlCategories($group: String!) {
    getForbiddenMlCategories(group: $group) {
        id
    }
  }
`;

export const useGetForbiddenMlCategoriesManual = (group: string = 'MLU') => {
  const [getForbiddenMlCategories, { loading, data }] = useManualQuery(GET_FORBIDDEN_ML_CATEGORIES, {
    variables: {
      group,
    },
  });

  return { getForbiddenMlCategories, loading, data };
}
